import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { situations } from '../data/content';
export function Situations() {
  return <section className="w-full bg-cream-200 px-4 py-20" data-id="element-139" data-mp="mz9kltryhztd">
      <div className="mx-auto max-w-5xl" data-id="element-140" data-mp="rxb5mk8y097h">
        <div className="text-center" data-id="element-141" data-mp="rw9iviikdy9x">
          <h2 className="font-display text-[26px] font-black leading-tight tracking-[-0.01em] text-ink sm:text-[32px]" data-id="element-142" data-mp="vzfw5a43gppw">
            <span aria-hidden="true" data-id="element-143" data-mp="10z0sdcrvqjyx">🙋‍♀️</span> Ti riconosci in queste situazioni?
          </h2>
          <p className="mt-3 font-sans text-[13px] text-ink-soft" data-id="element-144" data-mp="15x2gic45x9h9">
            Sono le frasi che ci ripetono ogni settimana centinaia di insegnanti.
          </p>
        </div>

        <ul className="mx-auto mt-9 grid max-w-4xl gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-145" data-mp="1fnf5cgj0fot7">
          {situations.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl border border-cream-300 bg-white px-4 py-4" data-id="element-146" data-mp="1jps24ffs4cdu">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-147" data-mp="3lhxz6y37t1nf">
                {item.icon}
              </span>
              <p className="font-sans text-[12.5px] leading-relaxed text-ink-soft" data-id="element-148" data-mp="3hft8a745ij4h">{item.text}</p>
            </li>)}
        </ul>

        <p className="mt-9 flex items-center justify-center gap-2 font-display text-[15px] font-bold italic text-brand" data-id="element-149" data-mp="3chrnnhr2ubqw">
          Ti servivi molto più di così
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-150" data-mp="9116c6q1oc9w" />
        </p>
      </div>
    </section>;
}